// Standard section shell with eyebrow + heading.
import { Reveal } from "./Reveal";

export default function Section({ id, eyebrow, heading, sub, children, className = "", center = false, testId }) {
  return (
    <section id={id} data-testid={testId} className={`relative mx-auto max-w-7xl px-5 py-20 sm:py-28 ${className}`}>
      {(eyebrow || heading) && (
        <Reveal className={`mb-12 ${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
          {eyebrow && (
            <span className="inline-flex items-center gap-2 rounded-full glass px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-brand">
              {eyebrow}
            </span>
          )}
          {heading && <h2 className="mt-5 text-3xl font-bold text-slate-900 sm:text-4xl lg:text-5xl">{heading}</h2>}
          {sub && <p className="mt-4 text-base text-slate-500 sm:text-lg">{sub}</p>}
        </Reveal>
      )}
      {children}
    </section>
  );
}
